import _ from 'underscore'
import Api from '../lib/request'
import cookie from '../lib/cookie'
import CONSTANT from '../constant'

const user = {
  exchangeToken(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'mall.user.oauth2.login',
      },
    }).then((data) => {
      if (data.status !== 0 || data.status === 6801040) {
        throw data
      }
      return data || {}
    })
  },
  authorize(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'mall.user.authorize',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      },
    })
      .then((data) => {
        return data
      })
      .catch((err) => {
        return data
      })
  },
  mobileChange(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'mall.user.mobile-change',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      },
    })
      .then((data) => {
        return data
      })
      .catch((err) => {
        return data
      })
  },
  mobileChangeCheck() {
    return Api.get(CONSTANT.REQUEST_HOST, {
      headers: {
        'X-Host': 'mall.user.mobile-change-check',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      },
    })
      .then((data) => {
        return data
      })
      .catch((err) => {
        return data
      })
  },
  exchangeTokenV5(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'mall.third.auth',
      },
    }).then((data) => {
      if (data.status !== 0 || data.status === 6814007) {
        throw data
      }
      return data || {}
    })
  },
  // header mall.user.info.get
  // status=4001 token error ,which is Authorized fail.
  // eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0aW1lc3RhbXAiOjE0OTYyMjE3MDQsInVzZXJJZCI6NDF9.819IR3V1DBVCXZKeY1Uw4376xyjZaY0_YdFGmlXFVYs
  detail(token) {
    return Api.get(CONSTANT.REQUEST_HOST, {
      headers: {
        'X-Host': 'mall.user.info.get',
        'X-Token': token,
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data.msg
      }
      return _.assign(
        {},
        {
          token,
        },
        data.data,
      )
    })
  },
  resetPassword(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'mall.user.password.reset',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data
      }
      return data || {}
    })
  },
  setSecurityCode(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'mall.user.paypwd.reset',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data
      }
      return data || {}
    })
  },
  getImgCaptcha() {
    return Api.get(CONSTANT.REQUEST_HOST, {
      headers: {
        'X-Host': 'mall.user.captcha',
        // "X-Token": cookie(CONSTANT.COOKIE_USER_X_TOKEN)
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data.msg
      }
      return data.data
    })
  },
  sendSmsCode(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'kaop.sms.send',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data
      }
      return data.data
    })
  },
  queryLogistic(orderId) {
    return Api.get(`${CONSTANT.REQUEST_HOST}?orderId=${orderId}`, {
      headers: {
        'X-Host': 'mall.order.logistic.query',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data.msg
      }
      return data.data
    })
  },
  login(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'mall.user.login',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data
      }
      return data.data
    })
  },
  smsLogin(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'mall.user.sms-code-login',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data
      }
      return data.data
    })
  },
  /**
   *
   * @param {object} option
   * @param {string} option.key
   * @param {string} option.phone
   * @param {string} option.smsCode
   * @param {number} option.openType
   * @param {string} option.imgKey
   * @param {string} option.imgCode
   */
  thirdBindMobile(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'mall.third-user.bind-mobile',
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data
      }
      return data.data
    })
  },
  bindMobile(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'mall.user.third.bind',
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data
      }
      return data.data
    })
  },
  signUp(option) {
    return Api.post(CONSTANT.REQUEST_HOST, option, {
      headers: {
        'X-Host': 'mall.user.regist',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data
      }
      return data.data
    })
  },
  getUserInfo() {
    return Api.get(`${CONSTANT.REQUEST_HOST}`, {
      headers: {
        'X-Host': 'mall.user.info.get',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      },
    }).then((data) => {
      if (data.status !== 0) {
        throw data.msg
      }
      return data.data
    })
  },
}

export default user
